







export default
  props: {
    show_close_button:
      type: Boolean
      default: false
    background_change:
      type: Boolean
      default: false
    width95:
      type: Boolean
      default: false
    height95:
      type: Boolean
      default: false
    width100:
      type: Boolean
      default: false
  }

  methods: {
    close_button:(e) ->
      @$emit('close_button')
  }
